import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminClients = z.any()
export type TagsGetAdminClients = z.infer<typeof tagsGetAdminClients>

export const querystringGetAdminClients = z.object({ "page": z.string().optional(), "perPage": z.string().optional(), "search": z.string().optional() })
export type QuerystringGetAdminClients = z.infer<typeof querystringGetAdminClients>

export const responseGetAdminClients = z.object({ "payload": z.array(z.object({ "id": z.string(), "name": z.string(), "email": z.string().email(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }), "municipalityCount": z.number(), "privileges": z.array(z.string()), "municipality": z.object({ "id": z.string(), "name": z.string(), "ico": z.string(), "parseLimit": z.number().optional() }).optional(), "municipalities": z.array(z.object({ "id": z.string(), "name": z.string(), "ico": z.string(), "parseLimit": z.number().optional() })).optional() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminClients = z.infer<typeof responseGetAdminClients>

interface IGetAdminClients extends BaseMethodType {
  tags: TagsGetAdminClients,
  querystring: QuerystringGetAdminClients,
  response: ResponseGetAdminClients
}
export const URL = '/admin/clients'
export const validation = {
  get: {
    tags: tagsGetAdminClients,
    querystring: querystringGetAdminClients,
    response: responseGetAdminClients
  }
}
export interface AdminClients extends BaseRouteType {
  get: IGetAdminClients
}